exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-templates-hype-thanks-tsx": () => import("./../../../src/templates/HypeThanks.tsx" /* webpackChunkName: "component---src-templates-hype-thanks-tsx" */),
  "component---src-templates-hype-tsx": () => import("./../../../src/templates/Hype.tsx" /* webpackChunkName: "component---src-templates-hype-tsx" */)
}

